<template>
  <div class="cdetailApp" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading" :style="'min-height:'+curHeight+'px'">
    <div class="title">{{setQkanDetail.title}}</div>
    <div class="see">
      <span>Time：{{setQkanDetail.createtime}}</span>
      <span>Click Count：{{setQkanDetail.seeNum}}次</span>
      <span>Comments：{{setComment.length}}次</span>
    </div>
    <div class="con" v-html="setQkanDetail.content"></div>

    <div class="comment">
      <h2>审核反馈</h2>
      <div class="txtEdit" v-if="setQkanDetail.status == 1">
        <div class="choose">
          <el-radio v-model="pshen" label="1">同意</el-radio>
          <el-radio v-model="pshen" label="2">拒绝</el-radio>
        </div>
        <textarea placeholder="请输入核定事由" v-model="content"></textarea>
        <div class="btn" @click="save">提交</div>
        <div style="clear:both"></div>
      </div>

      <ul class="lyan">
        <li v-for="(item,i) in setAllCheckny">
          <div class="user">
            <span>{{item.username}}</span>
            <font>{{item.createtime}}</font>
          </div>
          <p>{{item.content}}</p>
          <p>状态：<font :style="item.status == 1 ? 'color:green' : 'color:red'">{{item.status == 1 ? '已通过' : '已拒绝'}}</font></p>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
  import $ from 'jquery'
  export default {
    data() {
      return {
        curHeight:0,
        fullscreenLoading: false,
        baseUrl:'',
        pshen: '1',
        content:'',
        setQkanDetail:[],
        setComment:[],
        setAllCheckny:[]
      };
    },
    beforeMount() {
      this.baseUrl = this.$host;
    },
    mounted() {
      this.beforeMount();
      this.getQkanDetail();
    },
    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      save:function(){
        var that = this;
        if(that.content == ''){
          that.$alert('请输入核定事由', '提示');
          return false;
        }
        that.fullscreenLoading = true;
        var id = that.$route.query.id
        $.ajax({
          type:'post',
          url:that.$host+'home/index/checkny',
          data:{
            content:that.content,
            status:that.pshen,
            qikan_id:id,
            user_id:localStorage.getItem('qkan')
          },
          dataType:'json',
          success:function(data){
            if(data.status == 200){
              that.$alert(data.message, '提示');
              that.getAllCheckny();
            }else{
              that.$alert(data.message, '提示');
            }
            that.fullscreenLoading = false;
          }
        })
      },
      getQkanDetail:function(){
        var that = this;
        that.fullscreenLoading = true;
        var id = that.$route.query.id
        $.ajax({
          type:'post',
          url:that.$host+'home/index/qkanDetail',
          data:{
            id:id
          },
          dataType:'json',
          success:function(data){
            that.setQkanDetail = data.data;
            that.getAllCheckny();
            that.fullscreenLoading = false;
          }
        })
      },
      getAllCheckny:function(){
        var that = this;
        that.fullscreenLoading = true;
        var id = that.$route.query.id
        $.ajax({
          type:'post',
          url:that.$host+'home/index/allCheckny',
          data:{
            qikan_id:id
          },
          dataType:'json',
          success:function(data){
            that.setAllCheckny = data.data;
            that.fullscreenLoading = false;
          }
        })
      },
    },
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .cdetailApp .el-message-box{
    width:30%
  }
  .cdetailApp{
    max-width:750px;
    margin:0 auto;
    background:#fff;
    padding-bottom:8px
  }

  .cdetailApp .title{
    text-align:center;
    font-size:18px;
    padding:10px 0;
    font-weight:bold;
    width:96%;
    margin:0 auto;
    line-height:25px
  }
  .cdetailApp .see{
    width:92%;
    margin:0 auto;
    padding-bottom:15px;
    text-align:center;
  }
  .cdetailApp .see span{
    font-size:14px;
    padding-right:15px;
    color:#333
  }
  .cdetailApp .con{
    width:92%;
    margin:0 auto
  }
  .cdetailApp .con p {
    font-size: 16px;
    color: #333;
    letter-spacing: 1px;
    line-height: 24px;
    text-indent: 2em;
    margin-bottom:15px
  }
  .cdetailApp img {
    display: block;
    margin: 0 auto;
    width:100% !important
  }

  .cdetailApp .comment{
    background: #F1F2F5;
    width:96%;
    margin:0 auto
  }

  .cdetailApp .comment h2{
    width:94%;
    margin:0 auto;
    position:relative;
    font-size:16px;
    padding:8px 0 8px 2%;
  }
  .cdetailApp .comment h2:after{
    content:'';
    width: 4px;
    height: 14px;
    background: #000;
    position:absolute;
    left:0px;
    top:13px;
    border-radius: 3px;
  }
  .cdetailApp .comment .txtEdit{
    width:96%;
    background:#fff;
    margin:0 auto;
    padding:15px 0
  }
  .cdetailApp .comment .txtEdit .choose{
    width: 94%;
    margin:0 auto;
    display:block;
    margin-bottom:15px;
  }
  .cdetailApp .comment .txtEdit .choose .el-radio__inner{
    width:18px;
    height:18px;
  }
  .cdetailApp .comment .txtEdit .choose .el-radio__label{
    font-size:16px;
    color:#000;
  }
  .cdetailApp .comment .txtEdit textarea{
    width: calc(94% - 16px);
    margin:0 auto;
    display:block;
    border: 1px solid #E3E6EB;
    height:86px;
    resize:none;
    border-radius: 3px;
    outline:none;
    font-size:15px;
    color:#000;
    padding:8px
  }
  .cdetailApp .comment .txtEdit .btn{
    background: #0052D9;
    width: 80%;
    height: 42px;
    border-radius: 3px;
    color:#fff;
    text-align:center;
    line-height: 42px;
    margin-top:8px;
    margin:12px auto 0 auto;
    font-size:15px
  }

  .cdetailApp .comment .lyan{
    width: 92%;
    margin: 0 auto;
  }
  .cdetailApp .comment .lyan li{
    width:100%;
    margin:15px auto 0 auto;
    border-bottom:solid 1px #fff;
    padding-bottom:15px
  }
  .cdetailApp .comment .lyan li .user span{
    font-weight:bold;
    font-size:16px;
    color:#000
  }
  .cdetailApp .comment .lyan li .user font{
    float:right;
    font-size:14px;
    color:#666
  }
  .cdetailApp .comment .lyan li p{
    font-size:15px;
    color:#333;
    padding-top:8px;
    line-height:22px
  }
</style>